import axios from 'axios'
import React from 'react'
import './timesheets.css'
import EditTimesheet from '../CreateTimesheet/EditTimesheet/EditTimesheet'
import EditInvoice from './EditInvoice/EditInvoice'
import NewLoadingScreen from '../NewLoadingScreen/NewLoadingScreen'
import { baseUrl } from '../assets/Animations'
import SubmittingTimesheetPopup from './SubmittingTimesheetPopup/SubmittingTimesheetPopup'
import AdminCreateTimesheet from './AdminCreateTimesheet/AdminCreateTimesheet'
import ReportOfInvoicesGenerated from './ReportOfInvoicesGenerated/ReportOfInvoicesGenerated'
import AdminCreateInvoice from './AdminCreateInvoice/AdminCreateInvoice'
import OwnerMonthlyTimesheetOverview from './OwnerMonthlyTimesheetOverview/OwnerMonthlyTimesheetOverview'
import { changeTabs, enterHoverAnimation, leaveHoverAnimation } from './timesheetUtils'
import TimesheetsTab from './TimesheetsTab/TimesheetsTab'
import InvoicesTab from './InvoicesTab/InvoicesTab'
import UnbilledTab from './UnbilledTab/UnbilledTab'
import TimesheetDateSelector from './TimesheetDateSelector/TimesheetDateSelector'
import SchoolTabsTimesheet from './SchoolTabsTimesheet/SchoolTabsTimesheet'
import { format, getMonth, getDate, sub } from 'date-fns'
import AdminEditTimesheet2023 from './AdminEditTimesheet2023/AdminEditTimesheet2023'

const Timesheets = (props) => {
    const [currentMonth, setCurrentMonth] = React.useState('')
    const [currentYear, setCurrentYear] = React.useState('')
    const [month, setMonth] = React.useState('')
    const [year, setYear] = React.useState('')
    const [timesheets, setTimesheets] = React.useState([])
    const [invoices, setInvoices] = React.useState([])
    const [teachers, setTeachers] = React.useState([])
    const [students, setStudents] = React.useState([])
    const [tab, setTab] = React.useState('timesheets')
    const [schoolTab, setSchoolTab] = React.useState('mma')
    const schoolList = ['mma', 'lsma', 'tma', 'mor']
    const [adminCreateTimesheet, setAdminCreateTimesheet] = React.useState(false)
    const [adminCreateInvoice, setAdminCreateInvoice] = React.useState(false)
    const [openTimesheet, setOpenTimesheet] = React.useState(false)
    const [openInvoice, setOpenInvoice] = React.useState(false)
    const [listOfFamilies, setListOfFamilies] = React.useState([])
    const [currentFamilyName, setCurrentFamilyName] = React.useState('')
    const [processingTimesheet, setProcessingTimesheet] = React.useState(false)
    const [invoicesHaveBeenGenerated, setInvoicesHaveBeenGenerated] = React.useState(false)
    const [listOfInvoicesGeneratedSuccessfully, setListOfInvoicesGeneratedSuccessfully] = React.useState([])
    const [listOfTeachersTimesheetsForThisMonth, setListOfTeachersTimesheetsForThisMonth] = React.useState([])
    const [activeFamilies, setActiveFamilies] = React.useState([])
    const [familiesNotBilled, setFamiliesNotBilled] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    
    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

    React.useEffect(() => {
        initializeDateSettings()
        getTeachersAndStudents()
    }, [])

    React.useEffect(() => {
        changeTabs(tab, schoolList, schoolTab)
    }, [tab, schoolTab])

    React.useEffect(() => {
        (month !== '' && year !== '') && getTimesheets()
    }, [month, year])

    React.useEffect(() => {
        (timesheets !== [] && activeFamilies !== []) && whoHasNotBeenBilled()
    }, [activeFamilies])

    const getTimesheets = () => {
        axios.get(`${baseUrl}/alltimesheetdata/${month}/${year}` ,myHeader)
        .then((res) => {
            setTimesheets(res.data[0])
            setInvoices(res.data[1])
            setActiveFamilies(res.data[2])
        })
        .catch((err) => console.log(err))
    }

    const whoHasNotBeenBilled = () => {
        let filteredFamilies = activeFamilies
        timesheets.forEach((sheet) => sheet.families.forEach((fam) => filteredFamilies = filteredFamilies.filter((item) => item.familyName !== fam.familyName)))
        setFamiliesNotBilled(filteredFamilies)
    }

    const getTeachersAndStudents = () => {
        let endpoints = [`${baseUrl}/initialadminrequest`, `${baseUrl}/school-management`]
        Promise.all(endpoints.map((endpoint) => axios.get(endpoint, myHeader)))
        .then((res) => {
            res[0].data.forEach((teach) => teach.newStudentList = [])
            setTeachers(res[0].data)
            setStudents(res[1].data)
            calculateAndSortByNumberOfStudents(res[1].data, res[0].data)
        })
        .catch((err) => console.log(err))
    }

    const calculateAndSortByNumberOfStudents = (families, theTeachers) => {
        theTeachers.forEach((teach) => teach.newStudentList = [])
        families.forEach((fam) => {
            fam.familyStatus === 'Active' &&
                fam.students.forEach((famStudents) => {
                    famStudents.studentStatus === 'Active' &&
                        theTeachers.forEach((teach) => teach.TeacherID === famStudents.teachersId && teach.newStudentList.push({firstName: famStudents.studentName, lastName: fam.familyName}))
                })
        })
        setTeachers([...sortByAmountOfStudents(theTeachers)])
    }

    const sortByAmountOfStudents = (list) => {
        return list.sort((a, b) =>  b.newStudentList.length - a.newStudentList.length )
    }

    const initializeDateSettings = () => {
        if(getDate(new Date()) < 15) {
            setMonth(getMonth(new Date()) !== 0 ? format(sub(new Date(), {months: 1}), 'MMMM') : 'December')
            setCurrentMonth(getMonth(new Date()) !== 0 ? format(sub(new Date(), {months: 1}), 'MMMM') : 'December')
            setYear(getMonth(new Date()) !== 0 ? format(new Date(), 'yyyy') : format(sub(new Date(), {years: 1}), 'yyyy'))
            setCurrentYear(getMonth(new Date()) !== 0 ? format(new Date(), 'yyyy') : format(sub(new Date(), {years: 1}), 'yyyy'))
        } else {
            setMonth(format(new Date(), 'MMMM'))
            setCurrentMonth(format(new Date(), 'MMMM'))
            setYear(format(new Date(), 'yyyy'))
            setCurrentYear(format(new Date(), 'yyyy'))
        }
    }

    const callForListOfFamilies = async (school) => {
        let res = await axios.get(`${baseUrl}/schoolsfamilies/${school}`, myHeader)
        let sortedList = res.data.sort((a, b) => {
            return(a.familyName < b.familyName) ? -1 : (a.familyName > b.familyName) ? 1 : 0
        })
        setListOfFamilies(sortedList)
    }

    const markTimesheetAsApproved = async (id) => {
        axios.post(`${baseUrl}/approvetimesheet`, {timesheetId: id})
        .then((res) => updateTimesheets(res.data))
        .catch((err) => console.log(err))
    }

    const getAllInvoices = async () => {
        let returnedInvoices = await axios.get(`${baseUrl}/invoices/${month}/${year}`, myHeader)
        setInvoices(returnedInvoices.data)
        setProcessingTimesheet(false)
        setCurrentFamilyName('')
    }

    const generateInvoicesFromTimesheet = async (id) => {
        try{
            setProcessingTimesheet(true)
            //SET CURSOR TO LOADING
            document.body.style.cursor = 'wait'
            document.getElementById('admin-timesheet-submit-btn-for-loading').style.cursor = "wait"    
            //FIND THE CORRECT TIMESHEET
            let theTimesheet = timesheets.find((sheet) => sheet.timesheetId === id)
            let listOfFamiliesWeTriedToGenerateInvoicesFor = []
            //INCASE TIMESHEET IS EMPTY
            if(theTimesheet.families.length === 0) {
                markTimesheetAsApproved(theTimesheet.timesheetId)
                setOpenTimesheet(false)
                document.getElementById('admin-timesheet-submit-btn-for-loading').style.cursor = "default"
            }
            //LOOP THROUGH THE TIMESHEET & GENERATE INVOICES FROM IT
            theTimesheet.families.forEach((theFam) => {
                let invoicesStatus = 'Created'
                //CHECK FOR <24HR CANCELLATIONS
                theFam.cancellations.forEach((cancellation) => { cancellation.cancellor === 'student less than 24hrs' && theFam.lessons.push({ id: cancellation.id, studentName: cancellation.student, lessonLength: cancellation.lessonLength, studentRate: 0, date: cancellation.date })})
                //LIST ALL TEACHERS THAT TEACH THIS FAMILY
                let arrayOfTeachers = []
                theFam.listOfFamilyStudents.forEach((famsStudent) => {
                    famsStudent.studentStatus === 'Scholarship' && (invoicesStatus = 'Scholarship')
                    if(famsStudent.studentStatus === 'Active') {
                        arrayOfTeachers.filter(e => e.teachersId === famsStudent.teachersId).length === 0 &&
                            famsStudent.teachersId === theTimesheet.teacherId ? arrayOfTeachers.push({teachersId: famsStudent.teachersId, submittedTimesheet: true}) : arrayOfTeachers.push({teachersId: famsStudent.teachersId, submittedTimesheet: false})
                    }
                })
                setCurrentFamilyName(theFam.familyName)
                listOfFamiliesWeTriedToGenerateInvoicesFor.push({name: theFam.familyName, generated: false})
                let teacherInvoice = {
                    familyId: theFam.id,
                    familyName: theFam.familyName,
                    waveCustomerId: theFam.familyWaveId,
                    monthYear: theTimesheet.monthYear,
                    lessonsToBeBilled: theFam.lessons,
                    extrasToBeBilled: theFam.extras,
                    email: theFam.email,
                    paymentMethod: '',
                    status: invoicesStatus,
                    teachers: arrayOfTeachers,
                    school: theTimesheet.school,
                    autoPay: false,
                    monthNumber: theTimesheet.monthNumber,
                    year: theTimesheet.year
                }
                axios.post(`${baseUrl}/teacherinvoices`, {teacherInvoice})
                .then((res) => {
                    listOfFamiliesWeTriedToGenerateInvoicesFor.forEach((fam) => fam.name === res.data.familyName && (fam.generated = true))
                    document.body.style.cursor = 'default'
                    document.getElementById('admin-timesheet-submit-btn-for-loading').style.cursor = "default"
                    setInvoices([...invoices, res.data])
                    markTimesheetAsApproved(id)
                    setOpenTimesheet(false)
                })
                .catch((err) => {
                    console.log(err)
                    setOpenTimesheet(false)
                })
            })
            setInvoicesHaveBeenGenerated(true)
            setListOfInvoicesGeneratedSuccessfully([...listOfFamiliesWeTriedToGenerateInvoicesFor])
            getAllInvoices()
        } catch(e) {
            console.log(e)
        }
    }

    const updateTimesheets = (updatedTimesheet) => {
        setTimesheets(prev => prev.map(element => element.timesheetId === updatedTimesheet.timesheetId ? {...element, status: updatedTimesheet.status, families: updatedTimesheet.families} : element))
    }
    const updateInvoices = (updatedInvoice) => {
        setInvoices(prev => prev.map(element => element.invoiceId === updatedInvoice.invoiceId ? updatedInvoice : element))
    }
    const removeDeletedTimesheet = (id) => {
        setTimesheets(timesheets.filter(timesheet => timesheet.timesheetId !== id))
    }
    const removeDeletedInvoice = (id) => {
        setInvoices(invoices.filter(invoice => invoice.invoiceId !== id))
    }

    return(
        <div className="whole-billing-page">
            {loading && <NewLoadingScreen message={loading} />}
            {adminCreateTimesheet && <AdminCreateTimesheet setAdminCreateTimesheet={setAdminCreateTimesheet} setTimesheets={setTimesheets} />}
            {adminCreateInvoice && <AdminCreateInvoice setAdminCreateInvoice={setAdminCreateInvoice} updateInvoices={updateInvoices} setInvoices={setInvoices}/>}
            {processingTimesheet && <SubmittingTimesheetPopup currentFamilyName={currentFamilyName}/>}
            {invoicesHaveBeenGenerated && <ReportOfInvoicesGenerated listOfInvoicesGeneratedSuccessfully={listOfInvoicesGeneratedSuccessfully} setInvoicesHaveBeenGenerated={setInvoicesHaveBeenGenerated} />}
            {openTimesheet && <EditTimesheet callForListOfFamilies={callForListOfFamilies} timesheets={timesheets} openTimesheet={openTimesheet} setTimesheets={setTimesheets} listOfFamilies={listOfFamilies} timesheet={openTimesheet} families={openTimesheet.families} setOpenUpTheTimesheet={setOpenTimesheet} generateInvoicesFromTimesheet={generateInvoicesFromTimesheet}  updateTimesheets={updateTimesheets} removeDeletedTimesheet={removeDeletedTimesheet} listOfTeachersTimesheetsForThisMonth={listOfTeachersTimesheetsForThisMonth} setOpenTimesheet={setOpenTimesheet} />}
            {/* {openTimesheet && <AdminEditTimesheet2023 timesheet={openTimesheet} setTimesheet={setOpenTimesheet} />} */}
            {openInvoice && <EditInvoice  editting={true} invoice={openInvoice} setOpenInvoice={setOpenInvoice} updateInvoices={updateInvoices} removeDeletedInvoice={removeDeletedInvoice} />}
            <h1 className="whole-billing-page__title">Billing</h1>
            {props.userData.Name === 'Prescott Blackler' && <OwnerMonthlyTimesheetOverview timesheets={timesheets} teachers={teachers} students={students} invoices={invoices} />}
            <div className="date-selector-wrapper">
                <TimesheetDateSelector month={month} setMonth={setMonth} year={year} setYear={setYear} />
                <div className='timesheet__create-timesheet-btn' onClick={() => setAdminCreateTimesheet(true)}>Create Timesheet</div>
                <div className='timesheet__create-timesheet-btn timesheet__create-invoice-btn' onClick={() => setAdminCreateInvoice(true)}>Create Invoice</div>
            </div>
            <div className="whole-billing-page__tab-wrapper">
                <h5 className="whole-billing-page__tabs" id="timesheet-tab" onMouseEnter={() => enterHoverAnimation("timesheet-tab", 'timesheets', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("timesheet-tab", 'timesheets', tab, schoolTab)} onClick={() => setTab('timesheets')}>Timesheets</h5>
                <h5 className="whole-billing-page__tabs" id="invoices-tab" onMouseEnter={() => enterHoverAnimation("invoices-tab", 'invoices', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("invoices-tab", 'invoices', tab, schoolTab)} onClick={() => setTab('invoices')}>Invoices</h5>
                <h5 className="whole-billing-page__tabs" style={familiesNotBilled.length > 0 ? {color: 'red'} : {color: 'black'}} id="unbilled-tab" onMouseEnter={() => enterHoverAnimation("unbilled-tab", 'unbilled', tab, schoolTab)} onMouseLeave={() => leaveHoverAnimation("unbilled-tab", 'unbilled', tab, schoolTab)} onClick={() => setTab('unbilled')}>Unbilled Families</h5>
                {familiesNotBilled.length > 0 && <div className='unbilled-family-tab__number'>{familiesNotBilled.length}</div>}
            </div>
            {tab !== 'unbilled' && <SchoolTabsTimesheet timesheets={timesheets} invoices={invoices} tab={tab} setSchoolTab={setSchoolTab} schoolTab={schoolTab} />}
            <div>
                {tab === 'timesheets' && <TimesheetsTab  teachers={teachers} timesheets={timesheets} schoolList={schoolList}  schoolTab={schoolTab} currentMonth={currentMonth} currentYear={currentYear} month={month} year={year} setListOfTeachersTimesheetsForThisMonth={setListOfTeachersTimesheetsForThisMonth} setOpenTimesheet={setOpenTimesheet} />}
                {tab === 'invoices' && <InvoicesTab schoolList={schoolList} invoices={invoices} setInvoices={setInvoices} teachers={teachers} schoolTab={schoolTab} setOpenInvoice={setOpenInvoice} />}
                {tab === 'unbilled' && <UnbilledTab familiesNotBilled={familiesNotBilled} teachers={teachers} getFamilyData={props.getFamilyData} /> }
            </div>
        </div>
    )
}
export default Timesheets;